import React from 'react';
import { token } from '@atlaskit/tokens';

const NoActionSvg = () => (
	<svg
		width="107px"
		height="109px"
		viewBox="0 0 107 109"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
	>
		<defs>
			<rect id="path-1" x="0" y="0" width="96" height="96" rx="48" />
			<filter
				x="-6.2%"
				y="-4.2%"
				width="116.7%"
				height="116.7%"
				filterUnits="objectBoundingBox"
				id="filter-3"
			>
				<feOffset dx="2" dy="4" in="SourceAlpha" result="shadowOffsetOuter1" />
				<feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
				<feColorMatrix
					values="0 0 0 0 0.035   0 0 0 0 0.118   0 0 0 0 0.259  0 0 0 0.129999995 0"
					type="matrix"
					in="shadowBlurOuter1"
				/>
			</filter>
			<linearGradient x1="50%" y1="0.992398649%" x2="50%" y2="100%" id="linearGradient-4">
				<stop stopColor={token('color.icon.disabled')} offset="0%" />
				<stop stopColor={token('color.icon.accent.gray')} offset="100%" />
			</linearGradient>
		</defs>
		<g id="no-action" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
			<g id="Group" transform="translate(6.000000, 4.000000)">
				<mask id="mask-2" fill={token('color.background.input')}>
					<use href="#path-1" />
				</mask>
				<g id="Rectangle-3">
					<use
						fill={token('color.background.neutral')}
						fillOpacity="1"
						filter="url(#filter-3)"
						href="#path-1"
					/>
					<use fill={token('color.background.input')} fillRule="evenodd" href="#path-1" />
				</g>
				<path
					d="M28.0923219,42.8104916 C27.5886589,44.6209386 27.3194444,46.5290301 27.3194444,48.5 C27.3194444,60.1976978 36.8023022,69.6805556 48.5,69.6805556 C54.425212,69.6805556 59.7821609,67.2475325 63.6262937,63.3260397 L28.0923219,42.8104916 Z M32.5155044,34.6030496 L68.5321691,55.3972807 C69.2764477,53.2351963 69.6805556,50.9147904 69.6805556,48.5 C69.6805556,36.8023022 60.1976978,27.3194444 48.5,27.3194444 C42.1198903,27.3194444 36.3986478,30.1403901 32.5155044,34.6030496 Z M48.5,79 C31.6553151,79 18,65.3446849 18,48.5 C18,31.6553151 31.6553151,18 48.5,18 C65.3446849,18 79,31.6553151 79,48.5 C79,65.3446849 65.3446849,79 48.5,79 Z"
					id="Combined-Shape"
					fill="url(#linearGradient-4)"
				/>
			</g>
		</g>
	</svg>
);

export default NoActionSvg;
